import { render, staticRenderFns } from "./EmailTemplate.vue?vue&type=template&id=109b6874&scoped=true&"
import script from "./EmailTemplate.vue?vue&type=script&lang=js&"
export * from "./EmailTemplate.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplate.vue?vue&type=style&index=0&id=109b6874&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109b6874",
  null
  
)

export default component.exports